import type { ComponentProps } from 'react';

type RtlLogoProps = ComponentProps<'svg'> & {
  readonly colors?: [string, string, string];
};

const RtlLogo = ({ colors, ...props }: RtlLogoProps) => {
  return (
    <svg viewBox="0 0 160 28" focusable="false" role="img" {...props}>
      <title>RTL</title>
      <path fill={colors?.[0] ?? '#2a08b5'} d="M0 0h49.725v28H0z" />
      <path
        fill={colors?.[0] === '#ffffff' ? '#000' : '#fff'}
        d="M14.101 6.41h13.224c4.049 0 6.275 1.821 6.275 4.857 0 2.632-1.687 4.386-4.588 4.79l6.477 5.466h-4.993l-6.14-5.263H17.61v5.263h-3.441V6.41H14.1Zm12.82 7.017c2.159 0 3.17-.675 3.17-2.092s-1.011-2.092-3.17-2.092H17.61v4.184h9.31Z"
      />

      <path fill={colors?.[1] ?? '#6f0bed'} d="M54.718 0h49.725v28H54.718z" />
      <path
        fill={colors?.[1] === '#ffffff' ? '#000' : '#fff'}
        d="M77.86 9.378h-8.77V6.41h20.982v2.968h-8.77v12.145H77.86V9.378Z"
      />

      <path fill={colors?.[2] ?? '#ec33ec'} d="M109.436 0h49.725v28h-49.725z" />
      <path
        fill={colors?.[2] === '#ffffff' ? '#000' : '#fff'}
        d="M124.887 6.41h3.44v12.144h15.384v2.969h-18.824V6.41Z"
      />
    </svg>
  );
};

export default RtlLogo;
